import Vue from 'vue';
import _ from 'lodash';
import Router from 'vue-router';
import { NotFound, Debug, Login, Account, PasswordRecovery, dom, ApiKeyPersistance, CampaignValidate, Register } from '~';
import Switcher from '@/components/switcher/Switcher.vue';
import TmpDebug from '@/components/tmp-debug/TmpDebug.vue';
import Campaigns from '@/components/campaigns/Campaigns.vue';
import Creatives from '@/components/creatives/Creatives.vue';
import PublicCreativePreview from '@/components/public-creative-preview/PublicCreativePreview.vue';
import store from '@/store';
import VueCookie from 'vue-cookie';

const debug = Debug('router');

Vue.use(Router, VueCookie);

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/register', name: 'register', component: Register, meta: { public: true }, props: { platform: 'rabbit' } },
    { path: '/login', name: 'login', component: Login, meta: { public: true } },
    { path: '/could-not-sign-in', name: 'password-recovery', component: PasswordRecovery, meta: { public: true }, props: { platform: 'lab' } },
    { path: '/could-not-sign-in/:code', name: 'password-recovery-code', component: PasswordRecovery, meta: { public: true }, props: { platform: 'lab' } },
    { path: '/', name: 'home', redirect: '/campaigns' },
    { path: '/campaigns', name: 'campaigns', component: Campaigns },
    // TODO: remove this tmp redirect after 01jan2019
    { path: '/campaigns/:code', name: 'tmp-campaigns-redirect', redirect: to => ({ name: 'campaign', params: to.params }) },
    { path: '/campaign/:code/', name: 'campaign', component: Switcher, props: { component: 'campaign' } },
    { path: '/campaign-validate', name: 'campaign-validate', component: CampaignValidate },
    { path: '/customers', name: 'customers', component: Switcher, props: { component: 'customers' } },
    { path: '/customer/:id', name: 'customer', component: Switcher, props: { component: 'customer' } },
    { path: '/creatives', name: 'creatives', component: Creatives },
    { path: '/creative/:id/', name: 'creative', component: Switcher, props: { component: 'creative' } },
    { path: '/account', name: 'account', component: Account },
    { path: '/debug', name: 'tmp-debug', component: TmpDebug },
    { path: '/public-creative-preview/:id/:hash/:type', name: 'public-creative-preview', component: PublicCreativePreview, meta: { noTemplate: true, public: true } },
    { path: '*', name: 'not-found', component: NotFound, meta: { public: true } },
    // TODO: tmp redirect for authtoken/login
    { path: '/authtoken/login', name: 'tmp-login-redirect', redirect: to => ({ name: 'login', query: to.query }) },
  ],
});

router.beforeEach((to, from, next) => {
  //  Redirect non-authorized users to /login
  if (
    !_.has(to, 'meta.public') &&
    !store.getters['auth/getKey'] &&
    !Vue.cookie.get(ApiKeyPersistance.PERSISTENCE_KEY)
  ) {
    debug.info('redirecting non-authed user to /login');
    return next(`/login?next=${to.fullPath}`);
  }
  return next();
});

router.afterEach(to => {
  debug.info('navigated to %s', to.fullPath);
  dom.updateTitle();
  return Promise.resolve();
});

export default router;



// WEBPACK FOOTER //
// ./src/state/router.js